import { useQuery } from "@apollo/client/react";

import { getFragmentData } from "@/generated/graphql";
import { GetUserCategoriesDocument, UserCategoryFragmentDoc } from "@/generated/graphql/graphql";

type UseUserCategoriesProps = { skip?: boolean | undefined };

export function useUserCategories({ skip }: UseUserCategoriesProps) {
  const { data } = useQuery(GetUserCategoriesDocument, { skip });
  return getFragmentData(UserCategoryFragmentDoc, data?.userCategories || []);
}
